import DocsetMenu from "../../../../source/components/docset-menu";
import TierShield, { FurtherReading } from "../../../../source/components/TierShield";
import * as React from 'react';
export default {
  DocsetMenu,
  TierShield,
  FurtherReading,
  React
};